import React, { useState, useEffect } from "react";

import { ExpandMore } from "@mui/icons-material";
import TableComponent from "components/common/TableComponent";

import { getProfileImage } from "components/Screens/CommonUtils";

import { s3ImagesBaseURL } from "util/APIBaseUrl";
import { EMPLOYEE_BREAKDOWN_MONTHLY_PAYMENT_COLUMNS } from "./utils";

import "./PaymentBreakdown.scss";

function MonthlyPaymentEmployeeBreakdown({ employeesBreakdown = [] }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [employeeImages, setEmployeeImages] = useState({});
  const [tableData, setTableData] = useState([]);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const loadEmployeeImages = async () => {
      const imagePromises = employeesBreakdown.map(async (employee) => {
        if (employee.pictureVersion && employee.employeeId && !employee.employeeId.startsWith("employee-")) {
          try {
            const img = await getProfileImage(employee.employeeId, employee.pictureVersion);
            return { [employee.employeeId]: img };
          } catch (error) {
            return { [employee.employeeId]: `${s3ImagesBaseURL}/placeholder-avatar.svg` };
          }
        }
        const fallbackId = employee.employeeId || `employee-${employeesBreakdown.indexOf(employee)}`;
        return {
          [fallbackId]: `${s3ImagesBaseURL}/placeholder-avatar.svg`,
        };
      });

      const images = await Promise.all(imagePromises);
      const imageMap = images.reduce((acc, curr) => ({ ...acc, ...curr }), {});
      setEmployeeImages(imageMap);
    };

    if (employeesBreakdown.length > 0) {
      loadEmployeeImages();
    }
  }, [employeesBreakdown]);

  useEffect(() => {
    const transformedData = employeesBreakdown.map((employee, index) => {
      const employeeId = employee.employeeId || `employee-${index}`;
      const employeeImage = employeeImages[employeeId] || `${s3ImagesBaseURL}/placeholder-avatar.svg`;
      const { salary, raise, bonus, discount, total } = employee;
      return {
        id: employeeId,
        employeeName: employee.employeeName,
        employeeImage,
        currentSalary: salary,
        raise,
        bonus,
        discount,
        total,
      };
    });

    setTableData(transformedData);
  }, [employeesBreakdown, employeeImages]);

  return (
    <div className="payment-breakdown-container">
      <div className="payment-breakdown-header" onClick={handleToggle}>
        <h3 className="heading-h4-semibold color-text-heading-primary">Employee breakdown</h3>
        <ExpandMore className={`color-icon-secondary expand-icon ${isExpanded ? "rotated" : ""}`} />
      </div>

      <div className={`payment-breakdown-table-wrapper ${isExpanded ? "visible" : ""}`}>
        <TableComponent
          columns={EMPLOYEE_BREAKDOWN_MONTHLY_PAYMENT_COLUMNS}
          data={tableData}
          clientSidePagination
          initialRowsPerPage={10}
          noBorderForSingleRow
          disableSort={false}
          alternatingRows
          tableHeadSmall
          tableCellSmall
          noBorder
        />
      </div>
    </div>
  );
}

export default MonthlyPaymentEmployeeBreakdown;
